import React, { useState } from 'react'

import Section, { SectionBox } from '../../../components/Section'
import { MagicSelectForm } from '../../../components/Select/MagicSelectForm';

const Home: React.FC = () => {
const allOptions = [
  { value: "1", label: "JavaScript" },
  { value: "2", label: "TypeScript" },
  { value: "3", label: "React" },
  { value: "4", label: "Node.js" },
  { value: "5", label: "C#" },
];
 const [selected, setSelected] = useState<{ value: string; label: string }[]>([]);

    return(

        <>
            <Section name = "home">
                <SectionBox title = "Home">
                    {/* <div className="p-6">
      <MagicSelectForm
        options={allOptions}
        selected={selected}
        setSelected={setSelected}
        placeholder="Escolha linguagens..."
      />

      <pre className="mt-4 bg-gray-100 p-3 rounded">
        {JSON.stringify(selected, null, 2)}
      </pre>
    </div> */}
                </SectionBox>
            </Section>
        </>

    )

}

export default Home